import React, { useContext } from 'react';
import UserBasicInfoQRContext from '../../../components/Context/UserBasicInfoQRContext';
import { Link } from 'react-router-dom';
import UserBasicInfoContext from '../../../components/Context/UserBasicInfoContext';
import { SUPER_ADMIN_CODE } from '../ConstRole/ConstRole';


export default function ViewProfile() {

    const companyProfile = useContext(UserBasicInfoQRContext);
    const userProfile = useContext(UserBasicInfoContext);


    return (
        <div className=" w-full pb-10 pt-0">

            {(companyProfile?.logo) ?
                <>
                    <h1 className="font-bold text-lg mb-3 px-2">
                        Company Information 
                        
                        {(userProfile?.user_type_id === SUPER_ADMIN_CODE) &&    
                            <Link to={"/dashboard/company/edit-company"} state={{ data: companyProfile }} className="ml-3 py-1 px-2 justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-xs dark:focus:ring-offset-gray-800">
                                Edit
                            </Link>
                        }

                    </h1>
                    <table className="custom-details-table w-full mt-0 mb-2">
                        <tbody>
                            <tr>
                                <td className="font-semibold text-base">
                                    Logo
                                </td>
                                <td className="px-5 text-base">
                                    <div className='flex items-center'>
                                        {(companyProfile.logo) &&
                                            <img src={companyProfile.logo} alt="Business Logo" className='max-h-[100px] max-w-sm float-left mr-6 py-3' />
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">
                                    Banner
                                </td>
                                <td className="px-5 text-base">
                                    <div className='flex items-center'>
                                        {(companyProfile.banner_image) &&
                                            <img src={companyProfile.banner_image} alt="Banner" className='max-h-[100px] max-w-sm float-left mr-6 py-3' />
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Name</td>
                                <td className="px-5 text-base">
                                    {companyProfile.name}
                                </td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Phone</td>
                                <td className="px-5 text-base">{companyProfile.mobile_no}</td>
                            </tr>
                            <tr>
                                <td className="font-semibold text-base">Email Address</td>
                                <td className="px-5 text-base">{companyProfile.email}</td>
                            </tr>
                            
                        </tbody>
                    </table>
                </>
                :
                <table className="custom-details-table w-full mt-0 mb-2">
                    <tbody>
                        <tr>
                            <td className="font-semibold text-base">
                                Before proceeding, please select a company
                            </td>
                        </tr>
                    </tbody>
                </table>
            }

        </div>
    )
}
